import type { SessionUser } from "../../../shared/auth/access";

export function purchaseOrderScopeKey(user: SessionUser, previewKey: string | null) {
  return JSON.stringify([user.id, user.role, user.roles, user.permissions, user.dataScope, user.departmentId, user.preview, user.previewRole, previewKey]);
}
